var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillingCreditcardJcb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-57.5270968%",
    y1: "50.1241953%",
    x2: "232.39121%",
    y2: "50.1241953%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00873F",
    offset: "22.85%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40A737",
    offset: "74.33%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CB531",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.182516704%",
    y1: "49.95997%",
    x2: "100.273441%",
    y2: "49.95997%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00873F",
    offset: "22.85%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40A737",
    offset: "74.33%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CB531",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-62.8015845%",
    y1: "49.8578253%",
    x2: "253.671294%",
    y2: "49.8578253%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00873F",
    offset: "22.85%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40A737",
    offset: "74.33%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CB531",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.175556793%",
    y1: "50.0058048%",
    x2: "101.808162%",
    y2: "50.0058048%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F286F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004E94",
    offset: "47.51%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0066B1",
    offset: "82.61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006FBC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.575855512%",
    y1: "49.9142191%",
    x2: "98.13299%",
    y2: "49.9142191%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2C2F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#882730",
    offset: "17.35%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE1833",
    offset: "57.31%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC0436",
    offset: "85.85%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E60039",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Payment/JCB"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-11-Copy-3",
    fill: "#FFFFFF",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4827484,17.3941858 L22.9660409,17.3941858 C23.0084207,17.3941858 23.1073068,17.3800592 23.1496866,17.3800592 C23.4322185,17.3235529 23.6723707,17.0692742 23.6723707,16.7161093 C23.6723707,16.377071 23.4322185,16.1227923 23.1496866,16.0521593 C23.1073068,16.0380327 23.0225473,16.0380327 22.9660409,16.0380327 L21.4827484,16.0380327 L21.4827484,17.3941858 Z",
    id: "path6338",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7965218,8.02825319 C21.3838622,8.02825319 20.2254814,9.17250741 20.2254814,10.5992935 L20.2254814,13.26922 L23.8560164,13.26922 C23.940776,13.26922 24.0396621,13.26922 24.1102951,13.2833466 C24.9296376,13.3257264 25.5370812,13.7495243 25.5370812,14.4841072 C25.5370812,15.0632976 25.12741,15.5577285 24.3645738,15.6566146 L24.3645738,15.6848678 C25.1980429,15.7413742 25.8337397,16.2075518 25.8337397,16.9280082 C25.8337397,17.7049709 25.12741,18.2135284 24.1950547,18.2135284 L20.2113548,18.2135284 L20.2113548,23.4403686 L23.9831558,23.4403686 C25.3958153,23.4403686 26.5541961,22.2961144 26.5541961,20.8693283 L26.5541961,8.02825319 L22.7965218,8.02825319 Z",
    id: "path6349",
    fill: "url(#linearGradient-2)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4887249,14.6536264 C23.4887249,14.3145881 23.2485728,14.0885626 22.9660409,14.0461828 C22.9377877,14.0461828 22.8671547,14.0320562 22.8247749,14.0320562 L21.4827484,14.0320562 L21.4827484,15.2751966 L22.8247749,15.2751966 C22.8671547,15.2751966 22.9519143,15.2751966 22.9660409,15.26107 C23.2485728,15.2186902 23.4887249,14.9926646 23.4887249,14.6536264 L23.4887249,14.6536264 Z",
    id: "path6360",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.58516693,8.02825319 C7.17250741,8.02825319 6.0141266,9.17250741 6.0141266,10.5992935 L6.0141266,16.9421348 C6.73458295,17.2952997 7.4832925,17.5213252 8.23200205,17.5213252 C9.12197755,17.5213252 9.60228179,16.9845146 9.60228179,16.2499316 L9.60228179,13.2550934 L11.8060306,13.2550934 L11.8060306,16.235805 C11.8060306,17.3941858 11.0855743,18.3406677 8.64167331,18.3406677 C7.15838081,18.3406677 6,18.015756 6,18.015756 L6,23.426242 L9.77180093,23.426242 C11.1844605,23.426242 12.3428413,22.2819878 12.3428413,20.8552017 L12.3428413,8.02825319 L8.58516693,8.02825319 Z",
    id: "path6371",
    fill: "url(#linearGradient-4)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6908443,8.02825319 C14.2781848,8.02825319 13.119804,9.17250741 13.119804,10.5992935 L13.119804,13.9614232 C13.7696274,13.410486 14.899755,13.0573211 16.7220858,13.1420807 C17.6968209,13.1844605 18.7421889,13.4528658 18.7421889,13.4528658 L18.7421889,14.5406136 C18.2195049,14.2722083 17.5979347,14.0320562 16.7927188,13.9755498 C15.4083124,13.8766636 14.5748433,14.5547402 14.5748433,15.7413742 C14.5748433,16.9421348 15.4083124,17.6202114 16.7927188,17.5071986 C17.5979347,17.4506922 18.2195049,17.1964135 18.7421889,16.9421348 L18.7421889,18.0298826 C18.7421889,18.0298826 17.7109475,18.2982879 16.7220858,18.3406677 C14.899755,18.4254273 13.7696274,18.0722624 13.119804,17.5213252 L13.119804,23.4544952 L16.8916049,23.4544952 C18.3042645,23.4544952 19.4626453,22.310241 19.4626453,20.8834549 L19.4626453,8.02825319 L15.6908443,8.02825319 Z",
    id: "path6384",
    fill: "url(#linearGradient-5)",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingCreditcardJcb);
export default __webpack_public_path__ + "static/media/billing-creditcard-jcb.650fd4939877541a16beb628d5ac762f.svg";
export { ForwardRef as ReactComponent };